import {CLAIM_DETAIL, CLAIMS_DASHBOARD, CLAIMS_LIST, CLAIMS_REPAIR} from '../claims-commons/claims-commons-routing-roots';

export const CLAIMS_ADMIN_DASHBOARD: string = CLAIMS_DASHBOARD;
export const CLAIMS_ADMIN_LIST: string = CLAIMS_LIST;
export const CLAIMS_ADMIN_DETAIL: string = CLAIM_DETAIL;
export const CLAIMS_ADMIN_REPAIR: string = CLAIMS_REPAIR;

